import {Component, Input, OnInit} from '@angular/core';
import {CartElement} from '../../../../../projects/shared-lib/src/lib/models/cart-element';
import { CartHeaderComponent } from '../cart-header/cart-header.component';
import { CartDetailComponent } from '../cart-detail/cart-detail.component';
import { CartParkingComponent } from '../cart-parking/cart-parking.component';

@Component({
    selector: 'tw-rs',
    templateUrl: './rs.component.html',
    styleUrls: ['./rs.component.css'],
    imports: [CartHeaderComponent, CartDetailComponent, CartParkingComponent]
})
export class RsComponent implements OnInit {
    @Input() cartElement: CartElement;
    @Input() isInCheckout = false;
    openPrices = true;

    constructor() {
    }

    ngOnInit() {
    }

}
